import React from 'react';
import {observer} from 'mobx-react';
import {TsFloatingToolbarController} from './ts-floating-toolbar.controller';
import {FloatingToolbar} from '@techsee/techsee-ui-common/lib/floating-toolbar';

export interface TsFloatingToolBarContainerProps {
    controller: TsFloatingToolbarController;
}

@observer
export class TsFloatingToolBarContainer extends React.Component<TsFloatingToolBarContainerProps> {
    private containerRef = React.createRef<HTMLDivElement>();
    private initRetryTimeout?: NodeJS.Timeout;

    componentDidMount() {
        this.tryInitController();
    }

    componentDidUpdate() {
        this.tryInitController();
    }

    componentWillUnmount() {
        if (this.initRetryTimeout) {
            clearTimeout(this.initRetryTimeout);
        }
    }

    private tryInitController() {
        const {controller} = this.props;
        const container = this.containerRef.current;

        if (!controller || !container || controller.initialized) {
            return;
        }

        // Find the actual .floating-toolbar element
        const toolbarElement = container.querySelector('.floating-toolbar') as HTMLElement;

        if (!toolbarElement) {
            // Toolbar not rendered yet, retry on next update
            return;
        }

        // Try to initialize
        controller.init(toolbarElement);

        // If initialization failed (controller.initialized is still false), retry after a delay
        if (!controller.initialized) {
            this.initRetryTimeout = setTimeout(() => {
                this.tryInitController();
            }, 100);
        }
    }

    render() {
        const {controller} = this.props;

        if (!controller || !controller.shouldDisplay) {
            return null;
        }

        return (
            <div ref={this.containerRef} className='use-common-styles floating-toolbar-style'>
                <FloatingToolbar
                    position={controller.toolbarPos}
                    boundaries={controller.boundaries}
                    offset={controller.offsetBoundaries}
                    options={controller.toolbarOptions}
                    deviceCategory={controller.deviceCategory}
                />
            </div>
        );
    }
}
